module.exports = "<mat-tab-group>\r\n  <mat-tab>\r\n    <ng-template mat-tab-label>\r\n      <h4>Student File Upload</h4>\r\n    </ng-template>\r\n    <br>\r\n    <online-app-student-file-uploads></online-app-student-file-uploads>\r\n  </mat-tab>\r\n  <mat-tab>\r\n    <ng-template mat-tab-label>\r\n      <h4>Payment Methods</h4>\r\n    </ng-template>\r\n    <br>\r\n    <online-app-payment-methods></online-app-payment-methods>\r\n  </mat-tab>\r\n</mat-tab-group>"


//////////////////
// WEBPACK FOOTER
// ./src/app/additional-resources/additional-resources.component.html
// module id = hwx6
// module chunks = 2